'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useMemo, useEffect } from 'react';
import { Container, Wrapper, Title, ListJob } from './JobYouWillLove.css.js';
import { trackImpression, getSpecialJob, getJobYouWillLove } from './services.js';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import JobCardMini from '../JobCardMini/index.js';
import { buildJobUrl, buildCompanyUrl } from '../Utils/urlBuilder.js';
import Button from '../Button/index.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';
import { filterPrivateIP } from '../Utils/helpers.js';

var JobYouWillLove = function (props) {
    var typeOptions = props.typeOptions, api = props.api, langCode = props.langCode, utmType = props.utmType, utmString = props.utmString, robot = props.robot, previewJob = props.previewJob, _a = props.title, title = _a === void 0 ? '' : _a, isMobile = props.isMobile, isShowApplyAll = props.isShowApplyAll, _b = props.classSelector, classSelector = _b === void 0 ? '' : _b, titleNode = props.titleNode, userInfo = props.userInfo, _c = props.ignoreJobIds, ignoreJobIds = _c === void 0 ? [] : _c, getJobIdsProps = props.getJobIds, _d = props.enableTrackingImpression, enableTrackingImpression = _d === void 0 ? false : _d, _e = props.trackingImpressionSection, trackingImpressionSection = _e === void 0 ? 'none' : _e, _f = props.trackingData, trackingData = _f === void 0 ? null : _f;
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState({
        jobs: [],
        source: ''
    }), data = _h[0], setData = _h[1];
    var isCalledTracking = useRef(false);
    var _j = useState(null), jobYouWillLoveWrapperState = _j[0], setJobRef = _j[1];
    var isElementOnScreen = useElementOnScreen({
        target: jobYouWillLoveWrapperState,
        options: {
            isUseReactRef: false,
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    var isLoading = (robot === null || robot === void 0 ? void 0 : robot.enable) ? false : loading;
    var t = function (key) {
        if (langCode === ELanguage.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var createdUtm = function (type, source) {
        switch (type) {
            case 'my-profile':
                return "/?utm_source_navi=CareerCenter&utm_medium_navi=MyProfile&utm_campaign_navi=JobsYouWillLove&utm_content_navi=".concat(source, "&utm_term_navi=VB");
            case 'job-detail':
                return "/?utm_source_navi=jobalertemail&utm_medium_navi=JobDescription&utm_campaign_navi=PeopleAlsoView&utm_content_navi=".concat(source, "&utm_term_navi=VB");
            case 'job-detail-right-corner':
                return "/?utm_source_navi=jobdetail&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
            case 'event':
                return "/?utm_source_navi=eventPage&utm_medium_navi=rightcorner&utm_campaign_navi=relevantjobs&utm_content_navi=".concat(source);
            case 'competitive':
                return "?utm_source_navi=competitive&utm_medium_navi=job-will-love&utm_campaign_navi=result&utm_content_navi=".concat(source);
            case 'single-success-apply':
                return "?utm_source_navi=success-apply-single&utm_medium_navi=job-will-love&utm_campaign_navi=bottom&utm_content_navi=".concat(source);
            default:
                return utmString ? "".concat(utmString, "&utm_content_navi=").concat(source) : '';
        }
    };
    var formatJobs = function (jobs, source, ignoreJobIds) {
        var jobUnIgnore = (jobs || []).filter(function (job) { return !ignoreJobIds.includes(job.jobId); });
        return jobUnIgnore.map(function (item) {
            var locationText = '';
            if (item.workingLocations) {
                locationText = (item.workingLocations || [])
                    .map(function (item) { return (langCode === ELanguage.VI ? item.cityNameVI : item.cityName); })
                    .join(', ');
            }
            else if (item.locations) {
                locationText =
                    langCode === ELanguage.VI ? item.locations['1'].join(', ') : item.locations['2'].join(', ');
            }
            return __assign(__assign({}, item), { jobTitle: item.jobTitle, jobId: item.jobId, jobUrl: item.jobLink ||
                    buildJobUrl({
                        alias: item.alias,
                        jobId: item.jobId,
                        langCode: langCode,
                        utm: createdUtm(utmType || '', source)
                    }), companyLogo: item.companyLogo, company: item.company, companyUrl: buildCompanyUrl({ companyId: item.companyId, companySlug: item.company, langCode: langCode }), jobLevelText: langCode === ELanguage.VI ? item.jobLevelVI : item.jobLevel, jobLevelId: item.jobLevelId, address: item.address, jobDescription: item.jobDescription, jobRequirement: item.jobRequirement, isAnonymous: item.isAnonymous, locationText: locationText, prettySalary: item.prettySalary });
        });
    };
    var getJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clientIP, query, response, data, newData, jobs_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    clientIP = '';
                    if (typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'string') {
                        clientIP = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP;
                    }
                    else if ((trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) &&
                        typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'object' &&
                        (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP.length) > 0) {
                        clientIP = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === null || _a === void 0 ? void 0 : _a.join(',');
                    }
                    query = __assign(__assign({ jobId: '0' }, api.query), { clientIP: clientIP });
                    if (trackingImpressionSection !== 'none') {
                        query.section = trackingImpressionSection;
                    }
                    return [4 /*yield*/, getJobYouWillLove({
                            baseUrl: api.baseUrl,
                            langCode: langCode,
                            query: query,
                            smartNaviVersion: api.smartNaviVersion || 'v2',
                            formDataExcludeJobIds: api.formDataExcludeJobIds
                        })];
                case 1:
                    response = _b.sent();
                    data = response.data;
                    newData = formatJobs(data.jobs, data.source, ignoreJobIds);
                    if (!((api === null || api === void 0 ? void 0 : api.accessToken) && newData.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: newData
                        })];
                case 2:
                    jobs_1 = (_b.sent()).data;
                    setData({
                        jobs: jobs_1,
                        source: data.source
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setData({
                        jobs: newData,
                        source: data.source
                    });
                    _b.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var memoJobIds = useMemo(function () {
        if (!data.jobs || data.jobs.length < 1)
            return null;
        var jobIds = data.jobs.map(function (job) {
            return job.jobId;
        });
        return jobIds;
    }, [data.jobs]);
    useEffect(function () {
        if (!(robot === null || robot === void 0 ? void 0 : robot.enable)) {
            getJobs();
        }
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if (!isElementOnScreen || !enableTrackingImpression || isCalledTracking.current) {
            return;
        }
        var clientIP = '';
        if (typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'string') {
            clientIP = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP;
            var splittedClientIPs = clientIP.split(',').map(function (ip) { return ip.trim(); });
            var filterPublic = filterPrivateIP(splittedClientIPs);
            clientIP = filterPublic.length > 0 ? filterPublic[0] : clientIP;
        }
        else if ((trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) &&
            typeof (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === 'object' &&
            (trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP.length) > 0) {
            var filterPublic = filterPrivateIP(trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP);
            clientIP = filterPublic.length > 0 ? filterPublic[0] : (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.clientIP) === null || _a === void 0 ? void 0 : _a.join(',');
        }
        var jobIds = data.jobs.map(function (jobItem) { return jobItem.jobId; });
        trackImpression({
            baseMsUrl: api.baseUrl,
            langCode: langCode,
            body: {
                section: trackingImpressionSection,
                jobRecommend: jobIds,
                version: data.source,
                clientIP: clientIP,
                jobID: (_b = trackingData === null || trackingData === void 0 ? void 0 : trackingData.jobID) !== null && _b !== void 0 ? _b : -1,
                userID: (_c = trackingData === null || trackingData === void 0 ? void 0 : trackingData.userID) !== null && _c !== void 0 ? _c : ''
            }
        });
        isCalledTracking.current = true;
    }, [jobYouWillLoveWrapperState, isLoading, isElementOnScreen, data, enableTrackingImpression, isCalledTracking]);
    useEffect(function () {
        if (memoJobIds && (memoJobIds === null || memoJobIds === void 0 ? void 0 : memoJobIds.length) > 0) {
            getJobIdsProps && getJobIdsProps(memoJobIds);
        }
    }, [memoJobIds, getJobIdsProps]);
    var titleSection = title || t('Jobs You Will Love');
    var jobs = (robot === null || robot === void 0 ? void 0 : robot.enable) ? formatJobs(robot === null || robot === void 0 ? void 0 : robot.data, (robot === null || robot === void 0 ? void 0 : robot.source) || '', ignoreJobIds) : data.jobs;
    return !isLoading && jobs && (jobs === null || jobs === void 0 ? void 0 : jobs.length) > 0 ? (React__default.createElement(Container, { className: 'job-you-will-love', ref: function (ref) { return setJobRef(ref); } },
        React__default.createElement(Wrapper, { className: 'jobs-section' },
            titleNode || React__default.createElement(Title, { className: 'title' }, titleSection),
            React__default.createElement(ListJob, { gridColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridColumn, gridMobileColumn: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.gridMobileColumn, isMobile: isMobile }, jobs.map(function (item, idx) {
                var _a;
                return (React__default.createElement(JobCardMini, { key: idx, isMobile: isMobile, item: item, langCode: langCode, api: api, previewJob: previewJob, classSelector: classSelector, userInfo: userInfo, settingJob: {
                        isShowSkills: (_a = typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.isShowSkill) !== null && _a !== void 0 ? _a : false,
                        variant: typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.variant
                    }, initData: props.initData }));
            })),
            isShowApplyAll && data.jobs.length > 0 && (React__default.createElement(Button, { type: 'outline', onClick: function () {
                    return (window.location.href =
                        "".concat(window.location.origin, "/").concat(t('apply-multiple-jobs')) +
                            '/' +
                            data.jobs.map(function (item) { return item.jobId; }).join('_') +
                            createdUtm(utmType || '', data.source));
                }, style: { marginTop: 16, marginLeft: 'auto', display: 'block' } }, t('Apply All Jobs')))))) : (React__default.createElement(React__default.Fragment, null));
};

export { JobYouWillLove as default };
//# sourceMappingURL=index.js.map
